const SecUtils = {
  encode: (input: string): string => {
    let encodedString = '';
    const key = 'IXOYE';

    for (let i = 0; i < input.length; i++) {
      const inputChar = input.charCodeAt(i);
      const keyChar = key.charCodeAt(i % key.length);
      const encodedChar = String.fromCharCode((inputChar + keyChar) % 256);
      encodedString += encodedChar;
    }

    return encodedString;
  }
};

export { SecUtils };
